// Initialize and add the map
window.map;

window.initMap = async function (mapEleId, center, zoom) {
    const { Map } = await google.maps.importLibrary("maps");

    window.map = new Map(document.getElementById(mapEleId), {
        zoom: zoom || 10,
        center: center,
        mapId: "DEMO_MAP_ID",
    });
}
